// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

// REST/Storage go through the Cloudflare Worker proxy (bypasses ISP DNS blocks).
const SUPABASE_URL = "https://paxel.aleksander-509.workers.dev";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Realtime WebSocket goes DIRECT to Supabase. The worker proxy does not reliably
// forward WebSocket upgrade frames, which caused realtime subscriptions to fail.
// REST/Storage stay on the proxy URL above.
const REALTIME_DIRECT_URL = "wss://oxhzeuutqrestrjlcqfw.supabase.co/realtime/v1";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: { eventsPerSecond: 10 },
  },
});

// Override the realtime endpoint AFTER construction to avoid TS issues with
// the createClient options surface. The realtime client exposes `endPoint` /
// `endpoint` internally; we set both for safety across versions.
try {
  const rt = supabase.realtime as unknown as Record<string, unknown>;
  rt.endPoint = REALTIME_DIRECT_URL + "/websocket";
  rt.endpoint = REALTIME_DIRECT_URL + "/websocket";
} catch {
  /* noop */
}
